import { ERROR, FLUSH, MESSAGE, PROPERTY_DETAILS, PROPERTY_LIST, PROPERTY_REVIEWS, TIMELINE_DETAILS } from './constants';

const initialState = {
  error: null,
  list: [],
  message: null,
  details: {
    reviews: []
  }
};

export default function reducer (state = initialState, action) {
  switch (action.type) {
    
    case ERROR:
      return {
        ...state,
        error: action.error
      };

    case PROPERTY_LIST:
      return {
        ...state,
        list: action.result
      };

    case FLUSH:
      return {
        ...initialState
      };

    case MESSAGE:
      return {
        ...state,
        message: action.message
      };

    case PROPERTY_DETAILS:
      return {
        ...state,
        details: action.result
      };

    case PROPERTY_REVIEWS: 
      return {
        ...state,
        details: Object.assign({}, state.details, {
          reviews: action.result
        })
      };

    case TIMELINE_DETAILS: 
      return {
        ...state,
        timelineDetails: action.result
      };

    default: 
      return {
        ...state
      }
  }
}
